import { type Common } from './common.js';
import { type PaginatedQueryOptions } from './models/pagination/PaginatedQueryOptions.type.js';
import { type PaginationResponse } from './models/pagination/PaginationResponse.type.js';
import {
  type CreateValues,
  type FindAllOptions,
  type Procedure,
  type UpdateValues,
} from './models/procedure.js';

export class API {
  common: Common;
  baseEndpoint = '/procedures';

  constructor(common: Common) {
    this.common = common;
  }
  async findAllPaginated(
    options: PaginatedQueryOptions<FindAllOptions>
  ): Promise<PaginationResponse<Procedure>> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }
  async findAll(): Promise<Procedure[]> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.getJSON(url);
  }

  async create(values: CreateValues): Promise<Procedure> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, values);
  }

  async update(id: string, values: UpdateValues): Promise<Procedure> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.patchJSON(url, values);
  }

  async remove(id: string): Promise<boolean> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.deleteJSON(url);
  }
}
